import React from "react";
import KagithaneSidebar from "../Sidebar/KagithaneSidebar";
import KagithaneOtherServices from "../ServiceAreas/KagithaneServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const KagithaneIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        KAĞITHANE HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Kağıthane bölgesinde hijyenik yaşam alanları için güvenilir temizlik hizmetleri sunuyoruz.
            Halı, koltuk, yorgan ve perde yıkama işlemlerinde profesyonel kadromuz ve gelişmiş teknolojimizle
            fark yaratıyoruz. Evinizin havasını değiştirmek bizim işimiz.
          </p>

          <p>
            Halılarınızın her birine özel yıkama yöntemi uygulanarak, lif yapısına zarar vermeden temizlik sağlanır.
            Koltuklarınız ise kumaş cinsine göre buharlı ya da vakumlu sistemlerle temizlenir. Böylece bakteri, toz ve
            kötü kokular yok edilir.
          </p>

          <p>
            <strong>Kağıthane bölgesinde sunduğumuz başlıca avantajlar:</strong>
          </p>

          <ul className="list-disc list-inside">
            <li>Kağıthane’nin tüm mahallelerinden ücretsiz servis ve zamanında teslimat</li>
            <li>Organik ve cilt dostu temizlik ürünleri</li>
            <li>Yerinde koltuk yıkama ve yerinden alım hizmeti</li>
            <li>Yorgan, battaniye, halı ve perde yıkama çözümleri</li>
            <li>Kısa sürede teslimat (48 saat içinde)</li>
            <li>Leke çıkarma ve antibakteriyel uygulamalar</li>
          </ul>

          <p>
            Çağlayan, Gürsel, Hamidiye, Yahya Kemal, Emniyetevleri gibi Kağıthane mahallelerinde aktif hizmet sunuyoruz.
            Mobil servis araçlarımızla adresinize kadar geliyor, ürünlerinizi alıp temizleyip zamanında geri getiriyoruz.
          </p>

          <p>
            Halılarınız ve koltuklarınız detaylı temizlik işlemlerinin ardından özel ambalajlarla steril şekilde teslim edilir.
            Sağlıklı ve hijyenik bir ev ortamı için siz de hizmetimizden faydalanın.
          </p>

          <p>
            Hemen bizimle iletişime geçerek ücretsiz alım, fiyat bilgisi ve kampanyalar hakkında bilgi alabilirsiniz.
          </p>

          {/* Mahalle sidebar ve hizmet bölgeleri */}
          <KagithaneSidebar />
          <KagithaneOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default KagithaneIntro;
